
import React, { ChangeEvent, useEffect, useState } from 'react'
import Input from '../../components/UI/Input'
import SwitchInput from '../../components/UI/SwitchInput'
import { IConfigPageProps } from './types'
import { Divider, Input as AntdInput } from 'antd';
import { getConfigImages } from '../../services/config';
import { InputMode } from '../../enums/inputTypeEnum';
import {sendSystemLog, useAuth} from "../../context/AuthProvider/useAuth";
import {serverUrl} from "../../services/api";
import { onlyNumbers } from '../../utils/formValidation';

export const switchOptions = {
  check: 'true',
  uncheck: 'false',
}

interface IConfigMessagePageProps extends IConfigPageProps {
  setImage: (image: any) => void
}

function Messaging(props: IConfigMessagePageProps) {
  const [preview, setPreview] = useState<any|null>(null)
  const {canEdit} = useAuth()
  const log = {
    log_type: 'visited',
    log_object: 'system configs',
    object_name: 'messaging'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  const setConfig = (value: string, config: string) => {
    let currency = value ? onlyNumbers(value) : 0
    props.setConfig((parseInt((currency).toString()) * 100).toString(), config)
  }
  
  return (
    <div className="config-messaging">
      <div className="config-messaging__row">
        <SwitchInput
          label="High Prize Alert - Game Device"
          value={props.config.MSG_HIGHPRIZE_ENABLE}
          options={switchOptions}
          onChange={(e) => props.setConfig(e, 'MSG_HIGHPRIZE_ENABLE')}
          disabled={!canEdit}
        />
        {props.config.MSG_HIGHPRIZE_ENABLE === switchOptions.check && (
          <>
            <Input
              label='Big Win Minimum Prize Value'
              placeholder="value"
              value={(props.config.MSG_HIGHPRIZE_BIGWIN_MINVALUE && props.config.MSG_HIGHPRIZE_BIGWIN_MINVALUE != undefined && parseInt(props.config.MSG_HIGHPRIZE_BIGWIN_MINVALUE) === 0) ? '': (parseInt(props.config.MSG_HIGHPRIZE_BIGWIN_MINVALUE)/100).toString()}
              inputMode={InputMode.CURRENCY}
              onChange={(e: any) => setConfig(e.target.value, 'MSG_HIGHPRIZE_BIGWIN_MINVALUE')}
              type="number"
              disabled={!canEdit}
            />
            <Input
              label='Jackpot Minimum Prize Value'
              placeholder="value"
              inputMode={InputMode.CURRENCY}
              value={(props.config.MSG_HIGHPRIZE_JACKPOT_MINVALUE && props.config.MSG_HIGHPRIZE_JACKPOT_MINVALUE != undefined && parseInt(props.config.MSG_HIGHPRIZE_JACKPOT_MINVALUE) === 0) ? '' :(parseInt(props.config.MSG_HIGHPRIZE_JACKPOT_MINVALUE)/100).toString()}
              onChange={(e: any) => setConfig(e.target.value, 'MSG_HIGHPRIZE_JACKPOT_MINVALUE')}
              type="number"
              disabled={!canEdit}
            />
            <Input
              label='Jackpot Alert Pin Time (in minutes)'
              value={props.config.MSG_HIGHPRIZE_JACKPOT_NEW_SESSION_TIME}
              type="number"
              onChange={(e: any) => props.setConfig(e.target.value, 'MSG_HIGHPRIZE_JACKPOT_NEW_SESSION_TIME')}
              disabled={!canEdit}
            />
          </>
        )}
      </div>

    </div>
  )
}

export default Messaging